<template>
  <ListItem :order="order" class="green-card-list-item">
    <p class="green-card-list-item__info">Номер полісу: <strong>{{ order.id }}</strong></p>
    <p class="green-card-list-item__info">Номер авто: <strong>{{ order.details.vehicleNumber }}</strong></p>
  </ListItem>
</template>

<script>
import ListItem from '../list-item';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  components: { ListItem },
};
</script>

<style lang="scss" scoped>
.green-card-list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  @media (max-width: 550px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 16px;
  }

  &__info {
    font-family: inherit;
    font-size: 14px;
    font-weight: 400;
    color: #71717A;
    margin-right: 5px;


    strong {
      font-weight: 700;
    }
  }
}
</style>
